import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Table, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {shortDate, fullDate} from '../../../common/constants/datesFormat';
import {dealerOrdersStatus as status} from '../../../common/dictionaries/classification';
import {getOrderStatusName, getOrderTypeName, transportOptions} from '../common/utils';
import {SPECIAL_TYPE} from '../../constants';
import PartInfo from '../common/partInfo';

class OrderInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showBilling': false,
      'showSubstitutes': false,
    };
    this.handleShowIconClick = this.handleShowIconClick.bind(this);
    this.handleShowSubstitutesClick = this.handleShowSubstitutesClick.bind(this);
    this.handleShowClick = this.handleShowClick.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
  }

  handleShowIconClick() {
    this.setState({'showBilling': !this.state.showBilling});
  }

  handleShowSubstitutesClick() {
    this.setState({'showSubstitutes': !this.state.showSubstitutes});
  }

  handleShowClick() {
    const {order} = this.props;
    this.props.selectOrderForTrackingSchedule(order.orderSequence);
  }

  getDisabledStatus() {
    const {order} = this.props;
    const disabledStatus = [status.rejected, status.labeled, status.billed];

    if (order.orderType === SPECIAL_TYPE) {
      return [...disabledStatus,
        status.processed, status.denied, status.removed, status.inTransit].includes(order.status);
    }

    return disabledStatus.includes(order.status);
  }

  renderAttendedQuantity(value) {
    if (!value) {
      return 0;
    }

    return value;
  }

  renderBillingIcon() {
    const {order} = this.props;
    const {orderDetail} = order;

    if (!orderDetail.length || order.status === status.billed) {
      return null;
    }

    const iconName = this.state.showBilling ? 'minus circle' : 'plus circle';

    return (
      <Icon link size='large' color='blue' name={iconName} onClick={this.handleShowIconClick} />
    );
  }

  renderSubstituteIcon() {
    const {order} = this.props;

    if (!order.substitutedOrders || !order.substitutedOrders.length) {
      return null;
    }

    const iconName = this.state.showSubstitutes ? 'minus circle' : 'plus circle';

    return (
      <Icon
        link
        size='small'
        color='orange'
        name={iconName}
        title='Ver códigos sustituidos'
        style={{'verticalAlign': 'middle', 'marginLeft': '6px'}}
        onClick={this.handleShowSubstitutesClick}
      />
    );
  }

  renderBillingDetail(order) {
    if (!this.state.showBilling || !order.orderDetail.length) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table className='invoice-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Reserva</Table.HeaderCell>
                <Table.HeaderCell>ETA Estándar</Table.HeaderCell>
                <Table.HeaderCell>ETA Actualizada</Table.HeaderCell>
                <Table.HeaderCell>Factura de Importación</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderReception(order)}
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderSubstituteDetail() {
    const {order} = this.props;

    if (!this.state.showSubstitutes || !order.substitutedOrders || !order.substitutedOrders.length) {
      return null;
    }

    return (
      <Table.Row>
        <Table.Cell colSpan='100%'>
          <Table className='invoice-table'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código Solicitado</Table.HeaderCell>
                <Table.HeaderCell>Estado</Table.HeaderCell>
                <Table.HeaderCell>Observaciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {order.substitutedOrders.map((sub, i) => (
                <Table.Row key={i}>
                  <Table.Cell>{sub.partCode}</Table.Cell>
                  <Table.Cell>NEGADO</Table.Cell>
                  <Table.Cell>{`Sustituido por ${sub.substituteCode}`}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderReception(order) {
    const {orderDetail = []} = order;

    return orderDetail.map((detail, index) => (
      <Table.Row key={index}>
        <Table.Cell>{detail.reserveQuantity}</Table.Cell>
        <Table.Cell>{this.renderArriveDate(detail.arrivalDate)}</Table.Cell>
        <Table.Cell>{this.renderArriveDate(detail.etdDate)}</Table.Cell>
        <Table.Cell>{detail.billOrder}</Table.Cell>
      </Table.Row>
    ));
  }

  renderArriveDate(value) {
    if (!value) {
      return null;
    }

    return moment(value).format(shortDate);
  }

  renderTrackingIcon(order) {
    if (order.orderType !== SPECIAL_TYPE || order.status === status.entered || order.status === status.denied) {
      return null;
    }

    return (<Icon link size='large' color='blue' name='history' onClick={this.handleShowClick} />);
  }

  renderLoading() {
    return (
      <div className='force-gray-loader'
        style={{'display': 'flex', 'justifyContent': 'center', 'alignItems': 'center'}}>
        <style>{'.force-gray-loader i.icon { color: #767676 !important; }'}</style>
        <Icon loading name='spinner' size='large' />
      </div>
    );
  }

  render() {
    const {order} = this.props;

    return (
      <Fragment>
        <Table.Row negative={!!order.isDelayed ||
           (order.orderType === SPECIAL_TYPE && order.observations && order.observations.includes('Calculando ETA'))}>
          <Table.Cell>{order.orderCode}</Table.Cell>
          <Table.Cell>{getOrderTypeName(order.orderType)}</Table.Cell>
          <Table.Cell style={{'whiteSpace': 'nowrap'}}>
            <PartInfo partCode={order.partCode} partName={order.partName} />
            {this.renderSubstituteIcon()}
          </Table.Cell>
          <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>
            {this.renderBillingIcon()}
            {this.renderAttendedQuantity(order.attendedQuantity)}
          </Table.Cell>
          <Table.Cell>{moment(order.date).format(fullDate)}</Table.Cell>
          <Table.Cell>{transportOptions[order.dealerTransport]}</Table.Cell>
          <Table.Cell>{getOrderStatusName(order.status)}</Table.Cell>
          <Table.Cell>
            {order.user ? order.user.toUpperCase() : ''}
          </Table.Cell>
          <Table.Cell>{order.reference}</Table.Cell>
          <Table.Cell>
            {order.orderType === SPECIAL_TYPE && order.observations && order.observations.includes('Calculando ETA') ?
              this.renderLoading() :
              (order.etaStandard ? moment(order.etaStandard).format(shortDate) : null)}
          </Table.Cell>
          <Table.Cell>
            {order.etaUpdated ? moment(order.etaUpdated).format(shortDate) : null}
          </Table.Cell>
          <Table.Cell>{order.orderRepair}</Table.Cell>
          <Table.Cell>{order.billDate ? moment(order.billDate).format(fullDate) : null}</Table.Cell>
          <Table.Cell>{order.comment}</Table.Cell>
          <Table.Cell>{order.observations}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderTrackingIcon(order)}
          </Table.Cell>
        </Table.Row>
        {this.renderBillingDetail(order)}
        {this.renderSubstituteDetail()}
      </Fragment>
    );
  }
}

const {
  selectOrderForTrackingSchedule,
} = Actions;

export default connect(null, {
  selectOrderForTrackingSchedule,
})(OrderInfo);
